function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 389.34 389.34",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1EA6C6"
    },
    d: "M347.415,330.3c0,0.04,0,0.08,0,0.13c-40.37,36.61-93.96,58.91-152.74,58.91 c-58.79,0-112.38-22.3-152.75-58.91c0-0.05,0-0.09,0-0.13c0-60.89,35.63-113.45,87.17-137.98c19.37,19.32,42.05,29.73,65.58,29.73 c23.54,0,46.21-10.41,65.59-29.73C311.805,216.85,347.415,269.41,347.415,330.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD09F"
    },
    d: "M194.675,0c46.66,0,84.49,37.82,84.49,84.48c0,46.67-37.83,110.49-84.49,110.49 s-84.49-63.82-84.49-110.49C110.185,37.82,148.015,0,194.675,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.09631a35c0588c14bb492fe940b0b032.svg";
export { ForwardRef as ReactComponent };